import React from 'react';
import SuccessIcon from './success-icon.component';
import WarningIcon from './warning-icon.component';
import ErrorIcon from './error-icon.component';

const StatusBadge = ({ status, showText = true }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 1:
        return {
          icon: SuccessIcon,
          text: 'On panel',
          className: 'status-badge--success'
        };
      case 2:
        return {
          icon: WarningIcon,
          text: 'On panel',
          className: 'status-badge--warning'
        };
      case 3:
        return {
          icon: ErrorIcon,
          text: 'Not on panel',
          className: 'status-badge--error'
        };
      default:
        return {
          icon: SuccessIcon,
          text: 'On panel',
          className: 'status-badge--success'
        };
    }
  };

  const config = getStatusConfig();
  if(showText) {
    config.className += ' status-badge--with-text';
  }
  const Icon = config.icon;

  return (
    <div className={`status-badge ${config.className}`}>
      <Icon className="status-badge__icon" />
      {showText && <span className="status-badge__text">{config.text}</span>}
    </div>
  );
};

export default StatusBadge;
